module.exports = __webpack_public_path__ + "static/media/Alexis-Unarmored.78951aab.png";